
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Building, Plus } from 'lucide-react';

interface FacilityDetailsProps {
  productId: string;
}

export const FacilityDetails = ({ productId }: FacilityDetailsProps) => {
  // Mock facility data - in a real app, this would come from an API
  const facilities = [
    {
      id: '1',
      name: 'Main Manufacturing Plant',
      location: 'Portland, OR',
      certifications: ['ISO 9001', 'ISO 14001'],
      status: 'active'
    }
  ];

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">Manufacturing Facilities</CardTitle>
          <Button size="sm" variant="outline">
            <Plus className="h-4 w-4 mr-2" />
            Add Facility
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {facilities.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            <Building className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No facilities associated with this product</p>
          </div>
        ) : (
          <div className="space-y-3">
            {facilities.map((facility) => (
              <div key={facility.id} className="p-3 border rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-sm">{facility.name}</h3>
                  <Badge variant="outline" className="text-xs">
                    {facility.status}
                  </Badge>
                </div>
                <div className="text-xs text-muted-foreground space-y-1">
                  <p>{facility.location}</p>
                  <div className="flex flex-wrap gap-1">
                    {facility.certifications.map((cert) => (
                      <Badge key={cert} variant="secondary" className="text-xs">
                        {cert}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
